 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBADFRONT from '@/components/ebadfront'
 import TLU from '@/components/tlu'
 import AD1 from '@/components/ad1'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import AND from '@/components/and'
 import CONTENTS from '@/components/contents'
 import CHAPTER1 from '@/components/chapter1'
 import CHAPTER2 from '@/components/chapter2'
 import CHAPTER3 from '@/components/chapter3'
 import CHAPTER4 from '@/components/chapter4'
 import CHAPTER5 from '@/components/chapter5'
 import CHAPTER6 from '@/components/chapter6'
 import CHAPTER7 from '@/components/chapter7'
 import CHAPTER8 from '@/components/chapter8'
 import CHAPTER9 from '@/components/chapter9'
 import CHAPTER10 from '@/components/chapter10'
 import CHAPTER11 from '@/components/chapter11'
 import CHAPTER12 from '@/components/chapter12'
 import CHAPTER13 from '@/components/chapter13'
 import CHAPTER14 from '@/components/chapter14'
 import CHAPTER15 from '@/components/chapter15'
 import CHAPTER16 from '@/components/chapter16'
 import CHAPTER17 from '@/components/chapter17'
 import CHAPTER18 from '@/components/chapter18'
 import CHAPTER19 from '@/components/chapter19'
 import CHAPTER20 from '@/components/chapter20'
 import CHAPTER21 from '@/components/chapter21'
 import LOVE_2 from '@/components/love_2'
 import BIO from '@/components/bio'
 import COPYRIGHT from '@/components/copyright'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/chapter1",
 			"name" : "chapter1",
 			"component" : CHAPTER1
 		},
 		{
 			"path" : "/chapter2",
 			"name" : "chapter2",
 			"component" : CHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js